<!-- 列表 -->
<template>
  <div class="Sop-tabs">
    <div class="send-to-group" v-if="!showAdd">
      <div class="main-top">
        <el-input
          placeholder="输入搜索关键词"
          prefix-icon="el-icon-search"
          v-model="keywords"
          class="keywordsInput"
          @change="search"
        ></el-input>
        <el-button type="success" @click="ShowAdd">创建任务</el-button>
      </div>
      <el-card
        class="box-card"
        v-for="item in tableData"
        :key="item.id"
        v-show="tableData.length > 0"
      >
        <div slot="header" class="clearfix">
          <span>{{ item.ruleName }}</span>
        </div>
        <div>
          <el-table :data="changeMap(item)" style="width: 100%">
            <el-table-column
              prop="createTime"
              label="创建时间"
            ></el-table-column>
            <el-table-column prop="sendTime" label="执行时间"></el-table-column>
            <el-table-column prop="creator" label="创建人"></el-table-column>
            <el-table-column prop="sendType" label="类型">
              <template slot-scope="scope">
                <span v-if="scope.row.sendType === 1">定时推送</span>
                <span v-else>立即推送</span>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="覆盖用户量"></el-table-column>
            <el-table-column label="设置" width="180">
              <template slot-scope="scope">
                <el-button
                  @click="editPush(scope.row)"
                  type="text"
                  size="small"
                  :disabled="scope.row.isSend === 1"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteData(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
      <el-empty :image-size="200" v-show="tableData.length === 0"></el-empty>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageno"
        :page-sizes="[5, 10, 50, 100]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <AddPush v-if="showAdd" v-on:goBack="Back" :editData="editData"></AddPush>
  </div>
</template>

<script>
/* eslint-disable */
import {
  Message
} from 'element-ui'
import AddPush from "./component/AddPush";
import { getMassSendList, postMassSendDelte } from "@/service/sendtogroup";
export default {
  data () {
    return {
      tableData: [],
      keywords: "",
      showAdd: false,
      pageno: 1,
      pagesize: 5,
      showLineChart: false,
      mapData: null,
      editData: null,
      total: 0,
      sopType: '目标客户'
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created () {
    this.getInitList();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted () { },
  methods: {
    getInitList () {
      var data = { name: this.keywords, pageNo: this.pageno, pageSize: this.pagesize }
      getMassSendList(data).then(res => {
        this.tableData = res.list;
        this.total = res.num
      })
    },
    editPush (row) {
      console.log("🚀 ~ file: index.vue ~ line 112 ~ editDate ~ row", row)
      this.editData = row
      this.showAdd = true
    },
    deleteData (row) {
      var data = { id: row.id, msgId: row.msgId }
      postMassSendDelte(data).then(res => {
        Message.success('删除成功')
        this.getInitList();
      })
    },
    ShowAdd () {
      this.editData = null;
      this.showAdd = true;
    },
    Back () {
      this.showAdd = false;
      this.getInitList();
    },
    changeMap (item) {
      let arr = [];
      arr.push(item);
      return arr;
    },
    search () {
      this.getInitList();
    },
    handleCurrentChange (pageNo) {
      this.pageno = pageNo
      this.getInitList()
    },
    handleSizeChange (pageSize) {
      this.pagesize = pageSize
      this.getInitList()
    }
  },
  components: {
    AddPush
  }
};
</script>

<style lang='less'>
@import url("./index.less");
</style>